export default __webpack_public_path__ + "static/media/product-06 (2).7e74bec7.jpg";